exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-overlay[data-v-dd67c1ba] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.85);\n  z-index: 9999;\n  flex-direction: row;\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n", ""]);

// exports
